// Mise en forme minimale des textes saisis dans Strapi : **texte** -> gras.
// Le texte est échappé AVANT : aucune balise saisie dans l'admin n'est interprétée,
// seul le gras produit ici l'est (sortie sûre pour v-html).
const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }

export function rich(text) {
  return String(text || '')
    .replace(/[&<>"']/g, (c) => ESCAPES[c])
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
}
